import React, { Component } from 'react';
import { FormControl, FormGroup, ControlLabel, Radio } from 'react-bootstrap';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { CCOAlert, FieldGroup } from '../../util/Components.js';
import {clone, isNumeric} from '../../util/Utility.js';
import PanelEditView from '../../model/PanelEditView.js';


export default class EditAnnoucementView extends Component {

  constructor(props) {
    super(props);

    this.defaultObject = {
      title: "",
      content: "",
      expires: moment().add(7, 'd').unix(), //expiration date
      date: moment().unix(),
      originator: this.props.user.uid,
      ministryID: this.props.ministry ? this.props.ministry.key : -1
    };

    this.state = {
      object: props.new ? clone(this.defaultObject) : clone(this.props.object),
      titleAlert: false,
      dateError: false,
      dateType: "date",
      numberOfDays: ""
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.new !== this.props.new || newProps.show !== this.props.show || (newProps.object && this.props.object && newProps.object.key !== this.props.object.key) || (newProps.ministry && this.props.ministry && this.props.ministry.key !== newProps.ministry.key)) {
      if (newProps.new) {
        let object = clone(this.defaultObject);
        object.date = moment().unix();
        object.expires = moment().add(7, 'd').unix();
        object.ministryID = newProps.ministry.key;
        this.setState({object, dateType: "date", numberOfDays: ""});
      } else {
        this.setState({object: clone(newProps.object), dateType: "date", numberOfDays: ""});
      }
    }
  }

  dismissAlerts() {
    this.setState({titleAlert: false, dateError: false});
  }

  saveCheck() {
    return new Promise(function(resolve, reject) {

      let object = this.state.object;

      if (object.title === "" || object.content === "") {
        this.setState({titleAlert: true});
        reject();
      } else {
        if (this.state.dateType === "days") {
          if (!isNumeric(this.state.numberOfDays)) {
            this.setState({dateError: true, titleAlert: false});
            reject();
          } else {
            object.expires = moment().add(parseInt(this.state.numberOfDays), 'd').unix();
            resolve(object);
          }
        } else {
          resolve(object);
        }
      }
    }.bind(this));
  }

  render() {

    return (
      <PanelEditView title="Announcement" setState={this.setState.bind(this)} dismissAlerts={this.dismissAlerts.bind(this)} defaultObject={this.defaultObject} saveCheck={this.saveCheck.bind(this)} saveButtonTitle={this.props.new ? "Post" : null} {...this.props}>

        <FieldGroup id="title" label="Title" placeholder="Enter Text" context={this} comp="object" />
        <FieldGroup id="content" label="Content" placeholder="Enter Text"  context={this} comp="object" componentClass="textarea" help="Note: if you want to announce an event, meeting, or get together, please create an event under the event tab." />
        <FormGroup>
          <div style={{height: 8}} />
          <ControlLabel>Expiration</ControlLabel>
          <div style={{height: 5}} />
          <div>
            <Radio checked={this.state.dateType === "days"} style={{float: 'left', width: 80}} onChange={() => this.setState({dateType: "days"})}>Expire in </Radio>
            <FormControl type="text" style={{float: 'left', width: 70, marginTop: -7, marginRight: 10}} onChange={(e) => {
              this.setState({numberOfDays: e.target.value, dateType: "days"});
            }} value={this.state.numberOfDays} placeholder="#" />
            <p style={{marginLeft: 10}}> days</p>
          </div>

          <br></br>
          <div style={{height: 5}} />

          <div>
            <Radio checked={this.state.dateType === "date"} style={{float: 'left', width: 90}} onChange={() => {
              var obj = this.state.object;
              obj.expires = moment().add(7, 'd').unix();
              this.setState({dateType: "date", object: obj})
            }}>Expire on: </Radio>
            <div style={{float: 'left'}}><Datetime
              open={true}
              value={moment.unix(this.state.object.expires)}
              input={false}
              onChange={e => {
                var obj = this.state.object;
                obj.expires = e.unix();
                this.setState({object: obj, dateType: "date"}); }
              }
              timeFormat={false} /></div>
          </div>

          <div style={{height: 230}} />
          <br />
        </FormGroup>

        <center>
          <div style={{marginTop: 10, maxWidth: 250}}>
            <CCOAlert in={this.state.dateError} type="danger" title="Invalid Number of Days" content="Please enter only numeric values in the number of days field."  />
            <CCOAlert in={this.state.titleAlert} type="danger" title="Blank Fields" content="Please enter a Title and Content" />
          </div>
        </center>

      </PanelEditView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/ministry/announcements/EditAnnouncementView.js
 **/